import type { LexicalCommand, NodeKey } from 'lexical'
import { createCommand } from 'lexical'

export type ImagePayload = {
  src: string
  altText?: string
  height?: number
  width?: number
  file?: File
  key?: NodeKey
}

export type InsertImagePayload = Readonly<ImagePayload>

export const INSERT_IMAGE_COMMAND: LexicalCommand<InsertImagePayload> =
  createCommand('INSERT_IMAGE_COMMAND')
